// tslint:disable
export var CaseCaseFollowUpSyncAction;
(function (CaseCaseFollowUpSyncAction) {
    // Sync from Case Entities from Account Entities
    CaseCaseFollowUpSyncAction[CaseCaseFollowUpSyncAction["SyncFromAccount"] = 0] = "SyncFromAccount";
    // Complete
    CaseCaseFollowUpSyncAction[CaseCaseFollowUpSyncAction["SyncFromCase"] = 1] = "SyncFromCase";
    // Manually sync using case relationships in the CaseFollowUpResultModel
    CaseCaseFollowUpSyncAction[CaseCaseFollowUpSyncAction["Manual"] = 2] = "Manual";
})(CaseCaseFollowUpSyncAction || (CaseCaseFollowUpSyncAction = {}));
CaseCaseFollowUpSyncAction['SYNCFROMACCOUNT'] = 0;
CaseCaseFollowUpSyncAction['SYNCFROMCASE'] = 1;
CaseCaseFollowUpSyncAction['MANUAL'] = 2;
//# sourceMappingURL=CaseCaseFollowUpSyncAction.js.map